import React, { FC } from 'react';
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import EventRegistrationButton from 'buyside/components/presentation/EventPage/EventRegistrationButton/eventRegistrationButton';
import Link from 'buyside/components/presentation/Link/link';
import PublicRegistrationForm from 'buyside/components/presentation/EventPage/PublicRegistrationForm/publicRegistrationForm';

import styles from './eventRegistrationStyles.scss';

const EventRegistration: FC<{ isLoggedIn: boolean }> = ({ isLoggedIn }) => {
  return (
    <div className={styles.eventRegistrationContainer}>
      <div className={styles.eventRegistrationTitle}>
        <div className={styles.eventRegistrationMedia}>
          <img src="/images/event/hudson_commons.png" alt="Hudson Commons" />
          <span className={styles.eventRegistrationMediaCaption}>
            <FontAwesomeIcon icon={faImage} /> AlphaSense Hudson Yards venue
          </span>
        </div>
        <dl className={styles.eventDetails}>
          <div className={styles.eventDetailsRow}>
            <dt>Date</dt>
            <dd>Wednesday, June 10, 2026</dd>
          </div>
          <div className={styles.eventDetailsRow}>
            <dt>Time</dt>
            <dd>6:00 PM to 9:00 PM ET</dd>
          </div>
          <div className={styles.eventDetailsRow}>
            <dt>Location</dt>
            <dd>
              <div>AlphaSense NYC HQ</div>
              <div>441 9th Avenue, 4th Floor</div>
              <div>New York, NY 10001</div>
            </dd>
          </div>
          <div className={styles.eventDetailsRow}>
            <dt>Dress Code</dt>
            <dd>Business Casual</dd>
          </div>
        </dl>
      </div>
      {isLoggedIn ? <EventRegistrationButton /> : <PublicRegistrationForm />}
      <p className={styles.eventRegistrationSubtitle}>
        Submitting this form is a request to attend and does not guarantee confirmation. We will
        follow up shortly with additional details regarding attendance status, featured speakers,
        and final agenda timing. Capacity is limited to preserve the quality and intimacy of the
        discussion. If we're unable to confirm your attendance for this dinner, we hope you'll keep
        an eye out for similar events in the future. Please contact{' '}
        <Link to="mailto:support@sumzero.com">support@sumzero.com</Link> if you have any questions.
      </p>
    </div>
  );
};

export default EventRegistration;
